import { StyledComponent } from '@emotion/styled';
import { LinearProgress, linearProgressClasses, LinearProgressProps, styled } from '@mui/material';

import { Theme } from '../../theme/theme';

export const BorderedLinearProgress: StyledComponent<LinearProgressProps> = styled(LinearProgress)(
  ({ theme }: { theme: Theme }) => ({
    borderRadius: 5,
    height: 10,
    [`& .${linearProgressClasses.bar}`]: {
      backgroundColor: theme.palette.success.main,
      borderRadius: 5,
    },
  })
);
